import { render, staticRenderFns } from "./AdditionalProperties.vue?vue&type=template&id=07023d2e&scoped=true&"
import script from "./AdditionalProperties.vue?vue&type=script&lang=js&"
export * from "./AdditionalProperties.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalProperties.vue?vue&type=style&index=0&id=07023d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07023d2e",
  null
  
)

export default component.exports